import { GreetProps, GREET, GREETINGS_SHOW, GREETINGS_CLOSE } from './types'

const initialState = {
  status: false,
  stopAction: false,
}

export const GreetReducer = (state: GreetProps = initialState, action: GREET): GreetProps => {
  const { type, payload } = action

  switch (type) {
    case GREETINGS_SHOW:
      return {
        status: true,
        stopAction: payload,
      }
    case GREETINGS_CLOSE:
      return {
        status: false,
        stopAction: payload,
      }

    default:
      return state
  }
}
